var AppDispatcher = require('../dispatcher/app-dispatcher');
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var Constants = require('../constants/global');

EventEmitter.prototype._maxListeners = 100;

var _favorites = {}; // { 11111: true, 22222: true, 3333: false }

const CHANGE_EVENT = 'change';

var addFavorite = (id) => _favorites[id] = true;
var removeFavorite = (id) => _favorites[id] = false;
var setFavorites = (ids) => {
  _favorites = {};
  ids.forEach(id => _favorites[id] = true);
};

var FavoritesStore = assign({}, EventEmitter.prototype, {

  getAll: function() {
    return _favorites;
  },

  isFavorite: function(id) {
    return _favorites[id];
  },

  addChangeListener: function(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener: function(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  emitChange: function() {
    this.emit(CHANGE_EVENT);
  },

  dispatcherIndex: AppDispatcher.register(function(payload){
    var action = payload.action;

    switch(action.actionType) {
    case Constants.RECEIVE_ADDED_FAVORITE:
      addFavorite(action.id);
      FavoritesStore.emitChange();
      break;

    case Constants.RECEIVE_REMOVED_FAVORITE:
      removeFavorite(action.id);
      FavoritesStore.emitChange();
      break;

    case Constants.RECEIVE_ALL_FAVORITES:
      setFavorites(action.ids);
      FavoritesStore.emitChange();
      break;

    case Constants.UPDATE_FAVORITES:
      FavoritesStore.emitChange();
      break;
      
    default:
      return true;
    }
  })  
});

module.exports = FavoritesStore;



// WEBPACK FOOTER //
// ./stores/favorites-store.js